import {authApi} from "./auth-api";
import {setIsConfirmError, setIsEmailConfirmed, setIsLoginError, setToken} from "./auth-actions";
import {setProfile, setUser} from "../user/user-actions";
import {userApi} from "../user/user-api";
import instance from "../instance";
import {getUser} from "../user/user-thunks";


export const testAndConfirmEmail = (token) => async (dispatch, getState) => {
  const {user} = getState().userReducer
  try {
    const res = await authApi.confirmEmail(token)
    if (res.status === 200) {
      dispatch(setIsEmailConfirmed(true))
      dispatch(setUser({...user, is_active: true}))
    }
  } catch (e) {
    console.log(e)
    dispatch(setIsConfirmError(true))
    // dispatch(setToken(null))
  }
}

export const login = (email, password) => async (dispatch) => {
  dispatch(setIsLoginError(false))
  try {
    const response = await authApi.login(email, password)
    // todo old auth
    dispatch(setToken(response.data.access_token))
    console.log(response.data.access_token)
    localStorage.setItem('token', response.data.access_token)
    // localStorage.setItem('token', true.toString())
    // console.log(response.data)
    const res = await authApi.testToken(response.data.access_token)
    dispatch(setUser(res.data))
    // todo old auth
    // dispatch(setToken(true))
  } catch (e) {
    dispatch(setIsLoginError(true))
  }
}
